export default "__VITE_ASSET__10df22ed__"